import React, { useState } from 'react';
import Select from 'react-select';

interface TimezoneFormProps {
  timezoneOptions: { value: string; label: string }[];
  initialTimezone?: { value: string; label: string } | null;
  initialDisplayName?: string;
  onSubmit: (timezone: { value: string; label: string }, displayName: string) => void;
  onCancel: () => void;
  filterOption?: (option: { value: string; label: string }, inputValue: string) => boolean;
}

export function TimezoneForm({
  timezoneOptions,
  initialTimezone = null,
  initialDisplayName = '',
  onSubmit,
  onCancel,
  filterOption,
}: TimezoneFormProps) {
  const [selectedTimezone, setSelectedTimezone] = useState<{ value: string; label: string } | null>(
    initialTimezone
  );
  const [displayName, setDisplayName] = useState(initialDisplayName);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission behavior
    if (selectedTimezone) {
      onSubmit(selectedTimezone, displayName || selectedTimezone.value);
    } else {
      alert('Please select a timezone and enter a display name.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Select
        className="mt-3"
        options={timezoneOptions}
        value={selectedTimezone}
        onChange={(option) => setSelectedTimezone(option)}
        placeholder="Search and select a time zone..."
        isClearable
        filterOption={filterOption}
      />
      <input
        type="text"
        className="form-control mt-3"
        placeholder="Label (Optional)"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
      />
      <div className="mt-3">
        <button className="btn btn-primary" type="submit">
          {initialTimezone ? 'Save' : 'Add'}
        </button>
        <button className="btn btn-secondary ml-2" type="button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}